import React from 'react';
import { useConfig } from '@/config';
import * as m from '@/paraglide/messages.js';
import { getYear } from 'date-fns';

interface FooterProps {
  //   children: React.ReactNode;
  //   className?: string;
}

function websiteDisplay(url: string): string {
  return url.replace(/^https?:\/\/(www\.)?/, '');
}
/**
 *
 *
 * @param param0
 * @returns
 */
const Footer: React.FC<FooterProps> = () => {
  const { branding, contact } = useConfig();
  const siteDisplay = websiteDisplay(contact.website);
  return (
    <footer className="bg-[#1c2b4a] pt-16 pb-8 mt-14">
      <div className="max-w-300 mx-auto px-7">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 mb-12">
          {/* Brand col */}
          <div>
            <p className="text-sm font-extrabold tracking-[0.09em] uppercase text-white">
              {branding.companyName}
            </p>
            <p className="text-[0.65rem] font-semibold tracking-[0.12em] uppercase text-sky-400 mt-0.5 mb-3">
              {branding.appName}
            </p>
            <p className="text-[0.82rem] text-white/50 leading-[1.7] mb-5">
              {m.home_footer_tagline()}
            </p>
            <div className="flex gap-2">
              {['FB', 'TW', 'LI', 'IG'].map(label => (
                <a
                  key={label}
                  href="#"
                  className="w-8 h-8 rounded-lg bg-white/7 text-white/55 flex items-center justify-center text-[0.65rem] font-bold tracking-wide transition-all hover:bg-teal-600 hover:text-white"
                >
                  {label}
                </a>
              ))}
            </div>
          </div>

          {/* Support col */}
          <div>
            <h4 className="text-[0.72rem] font-bold tracking-[0.11em] uppercase text-white/35 mb-3.5">
              {m.home_footer_support_col()}
            </h4>
            <ul className="flex flex-col gap-2">
              {[
                m.home_footer_link_claims(),
                m.home_footer_link_contact(),
                m.home_footer_link_emergency(),
                m.home_footer_link_faq(),
                m.home_footer_link_travel(),
                m.home_footer_link_blog(),
              ].map(label => (
                <li key={label}>
                  <a
                    href="#"
                    className="text-[0.82rem] text-white/58 transition-colors hover:text-white"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company col */}
          <div>
            <h4 className="text-[0.72rem] font-bold tracking-[0.11em] uppercase text-white/35 mb-3.5">
              {m.home_footer_company_col()}
            </h4>
            <ul className="flex flex-col gap-2">
              {[
                {
                  label: m.home_footer_link_about({
                    companyName: branding.companyName,
                  }),
                  href: '#',
                },
                { label: m.home_footer_link_careers(), href: '#' },
                { label: siteDisplay, href: contact.website },
              ].map(item => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    target={
                      item.href === contact.website ? '_blank' : undefined
                    }
                    rel={
                      item.href === contact.website
                        ? 'noopener noreferrer'
                        : undefined
                    }
                    className="text-[0.82rem] text-white/58 transition-colors hover:text-white"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/7 pt-5.5 flex flex-wrap items-center justify-between gap-3">
          <p className="text-[0.76rem] text-white/35">
            &copy;{`${getYear(new Date())} `}
            {m.home_footer_copyright({ companyName: branding.companyName })}
          </p>
          <div className="flex gap-5">
            {['Privacy Policy', 'Terms of Service', 'Accessibility'].map(
              link => (
                <a
                  key={link}
                  href="#"
                  className="text-[0.76rem] text-white/35 transition-colors hover:text-white/65"
                >
                  {link}
                </a>
              )
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
